import ReactDOM from 'react-dom/client'
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import GemaraApp from './components/gemara-app/GemaraApp';
import SourceList from './components/sources/SourceList';

const root = ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={ <GemaraApp /> } />
        <Route path="/sources" element={ <SourceList /> } />
      </Routes>
    </BrowserRouter>
);